<div class="casino_division">
    <h4><button class="casino-back" (click)="back()">Back</button> {{gameName}}
      <div class="casino-min-max">
        <span *ngIf="settings?.min_bet"><b>Min:</b> {{settings?.min_bet}}</span>
        <span *ngIf="settings?.max_bet"><b>Max:</b> {{settings?.max_bet}}</span>
        <span *ngIf="settings?.max_market_profit"><b>Max Market Profit:</b> {{settings?.max_market_profit}}</span>
      </div>
    </h4>
    <iframe scrolling="yes" [src]="iframeUrl | safeURL" allowfullscreen="true" title="game" id="casino-link"></iframe>
</div>
